import { render, staticRenderFns } from "./AlternativesComparisonDialog.vue?vue&type=template&id=d03cc43c"
import script from "./AlternativesComparisonDialog.vue?vue&type=script&lang=ts"
export * from "./AlternativesComparisonDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports